import React from "react";
import "./AppErrorBoundary.css";
import i18n from "../i18n";

class AppErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unexpected application error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-error-boundary" role="alert">
          <div className="app-error-boundary__content">
            <h1>{i18n.t("something_went_wrong")}</h1>
            <p>{i18n.t("unexpected_error_description")}</p>
            <button type="button" onClick={this.handleReload}>
              {i18n.t("reload_page")}
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
